import type { ApiIdentity } from '$lib/api/types';
import { currentIdentity } from '$lib/state/current-identity';

export const ssr = false;
export const prerender = false;

// ─── Streaming identity ──────────────────────────────────────────────────
//
// load() returns synchronously with a Promise; the layout chrome paints
// immediately, identity hydrates in the background, and the auth redirect
// for unauthenticated visitors fires when the promise resolves. The memo
// lives in $lib/state/current-identity so member-only route gates and the
// admin gate share the same current /me read instead of each fetching.

export function load(): { identityPromise: Promise<ApiIdentity | null> } {
  return { identityPromise: currentIdentity() };
}
